<app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">
  <form [formGroup]="form.formGroup" class="h-full w-full">
    <p-toolbar>
      <ng-template #start>
        <div class="flex p-1">
          <label for="showCementSlurryPlot" class="mr-2">Show Plot</label>
          <p-toggleswitch inputId="showCementSlurryPlot" (onChange)="tablePlotToggle()"></p-toggleswitch>
        </div>
      </ng-template>

      <ng-template #end>
        <div class="flex">
          <svg-icon
            src="../../assets/icons/reset-default-24x24.svg"
            class="w-[25px] h-[25px] tree-icon cursor-pointer"
            (click)="applyDefaults()"
            title="Apply Defaults">
          </svg-icon>
        </div>
      </ng-template>
    </p-toolbar>

    <div class="w-full flex flex-col pb-4">
      @if (!showPlot) {
        <div class="mt-2 space-y-1">
          <div>
            <label for="nominalDensity">Density</label>
            <app-validated-number-input
              [id]="'density'"
              [control]="control('density')"
              [value]="control('density').value"
              [validation]="densityValidation"
              [unit]="densityUnits"
            ></app-validated-number-input>
          </div>

          <div>
            <label for="mixWaterDensity">Mix-Water Density</label>
            <app-validated-number-input
              [id]="'mixWaterDensity'"
              [control]="control('mixWaterDensity')"
              [value]="control('mixWaterDensity').value"
              [validation]="mixWaterDensityValidation"
              [unit]="densityUnits"
            ></app-validated-number-input>
          </div>

          <div>
            <label for="densityTemperature">Density Temperature</label>
            <app-validated-number-input
              [id]="'densityTemperature'"
              [control]="control('densityTemperature')"
              [value]="control('densityTemperature').value"
              [validation]="temperatureValidation"
              [unit]="tempUnit"
            ></app-validated-number-input>
          </div>
        </div>
      } @else {
        <app-xy-line-plot [plotData]="plot.data" [xAxisTitle]="xAxisTitle" [yAxisTitle]="yAxisTitle" [plotName]="plotName"
          [downloadPlotName]="downloadPlotName" [reverseAutoRange]="true" [plotTitle]="'Fluids'"
          [xyLinePlotStore]="fluidsStore">
        </app-xy-line-plot>
      }
    </div>

    <p-fieldset legend="Rheology">
      <div class="flex gap-2">
        <div class="flex flex-col w-1/3 space-y-2">
          <div class="flex flex-col">
            <label for="r600">R600</label>
            <app-validated-number-input
              [id]="'fann600'"
              [control]="control('fann600')"
              [value]="control('fann600').value"
              [validation]="{ min: 0.1, max: 500, required: false }"
              [unit]="''"
            ></app-validated-number-input>
          </div>

          <div class="flex flex-col">
            <label for="r100">R100</label>
            <app-validated-number-input
              [id]="'fann100'"
              [control]="control('fann100')"
              [value]="control('fann100').value"
              [validation]="{ min: 0.1, max: 500, required: false }"
              [unit]="''"
            ></app-validated-number-input>
          </div>
        </div>

        <div class="flex flex-col w-1/3 space-y-2">
          <div class="flex flex-col">
            <label for="r300">R300</label>
            <app-validated-number-input
              [id]="'fann300'"
              [control]="control('fann300')"
              [value]="control('fann300').value"
              [validation]="{ min: 0.1, max: 500, required: false }"
              [unit]="''"
            ></app-validated-number-input>
          </div>

          <div class="flex flex-col">
            <label for="r6">R6</label>
            <app-validated-number-input
              [id]="'fann6'"
              [control]="control('fann6')"
              [value]="control('fann6').value"
              [validation]="{ min: 0.1, max: 500, required: false }"
              [unit]="''"
            ></app-validated-number-input>
          </div>
        </div>

        <div class="flex flex-col w-1/3 space-y-2">
          <div class="flex flex-col">
            <label for="r200">R200</label>
            <app-validated-number-input
              [id]="'fann200'"
              [control]="control('fann200')"
              [value]="control('fann200').value"
              [validation]="{ min: 0.1, max: 500, required: false }"
              [unit]="''"
            ></app-validated-number-input>
          </div>

          <div class="flex flex-col">
            <label for="r3">R3</label>
            <app-validated-number-input
              [id]="'fann3'"
              [control]="control('fann3')"
              [value]="control('fann3').value"
              [validation]="{ min: 0.1, max: 500, required: false }"
              [unit]="''"
            ></app-validated-number-input>
          </div>
        </div>
      </div>

      <div class="mt-2">
        <label for="rheologyTemperature">Rheology Temperature</label>
        <app-validated-number-input
          [id]="'rheologyTemperature'"
          [control]="control('rheologyTemperature')"
          [value]="control('rheologyTemperature').value"
          [validation]="{ min: temperatureValidation.min, max: temperatureValidation.max }"
          [unit]="tempUnit"
        ></app-validated-number-input>
      </div>

      <div class="flex mt-2">
        <div class="flex flex-col w-1/2">
          <div>
            <label>PV:&nbsp; {{ plasticViscosity }} &nbsp;{{ plasticViscosityUnit }}</label>
          </div>
          <div>
            <label>YP:&nbsp; {{ yieldPoint }} &nbsp;{{ yieldPointUnit }}</label>
          </div>
        </div>

        <div class="flex flex-col w-1/2">
          <div>
            <label>n':&nbsp; {{ nPrime | number }}</label>
          </div>
          <div>
            <label>K':&nbsp; {{ kPrime | number }} &nbsp;{{ kPrimeUnit }}</label>
          </div>
        </div>
      </div>
    </p-fieldset>
  </form>
</app-tool-loader>